function t(...t){return t.reduce(((t,n)=>null==n?t:function(...u){t.apply(this,u),n.apply(this,u)}),(()=>{}))}export{t as default};
//# sourceMappingURL=createChainedFunction.js.map
